// EmployeeSalarySummary

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { ReportPageShell } from "../../components/ui/reportPageShell";
import { SALARYSUMMARY_REPORTS } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";

const EmployeeSalarySummary = () => {
    const [employeeSalarySummaryData, setEmployeeSalarySummaryData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);

    // Helper function to render object values safely
    const renderObjectValue = (value, keyToShow = "TOTAL") => {
        console.log("Value:", value);
        console.log("Key to show:", keyToShow);

        // Handle null or undefined values
        if (value === null || value === undefined) {
            return "-";
        }

        // If it's an object, try to get the specified key
        if (typeof value === 'object' && !Array.isArray(value)) {
            const result = value[keyToShow];
            return result !== null && result !== undefined ? result : "-";
        }

        // If it's not an object, return the value as is (or format it if needed)
        return value ?? "-";
    };

    const employeeSalarySummaryColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "salary_for",
            Header: "Salary For",
            sortable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            // Already a display label from the API (SALARY_TYPE_LABELS), so there
            // is nothing to map here. The CSV/PDF cell differs only in casing,
            // because tools.utils.format_string capitalizes every export value.
            accessor: "salary_type",
            Header: "Salary Type",
            sortable: true,
            Cell: ({ value }) => value || "-",
        },
        {
            accessor: "earnings",
            Header: "Earnings",
            Cell: ({ value }) => renderObjectValue(value, "TOTAL"), // Show TOTAL from earnings object
        },
        {
            accessor: "credits",
            Header: "Credit",
            filterable: true,
            Cell: ({ value }) => renderObjectValue(value, "TOTAL"), // Show TOTAL from credits object
        },
        {
            accessor: "deductions",
            Header: "Deduction",
            Cell: ({ value }) => renderObjectValue(value, "TOTAL"), // Show TOTAL from deductions object
        },
        {
            accessor: "debit",
            Header: "Debit",
            Cell: ({ value }) => renderObjectValue(value, "TOTAL"), // Show TOTAL from debit object
        },
        {
            accessor: "paid_salary",
            Header: "Take Home",
            sortable: true,
            Cell: ({ value }) => value ?? "-",
        }
    ];

    return (
        <ReportPageShell title="Employee Salary Summary Report" count={totalRecords}>
            <Reactable
                columns={employeeSalarySummaryColumns}
                data={employeeSalarySummaryData}
                setData={setEmployeeSalarySummaryData}
                setTotalCount={setTotalRecords}
                url={SALARYSUMMARY_REPORTS}
                serverSide={true}
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isMonthYearRequired={true}
            />
        </ReportPageShell>
    );
}

export default EmployeeSalarySummary;